import { z } from "zod";
export const STORAGE_BACKENDS = ["local", "sharepoint", "teams"];
export const createArtifactSchema = z.object({
    companyId: z.string().uuid(),
    agentId: z.string().uuid().optional(),
    issueId: z.string().uuid().optional(),
    runId: z.string().uuid().optional(),
    name: z.string().min(1).max(500),
    mimeType: z.string().min(1),
    sizeBytes: z.number().int().nonnegative().optional(),
    storageBackend: z.enum(STORAGE_BACKENDS).optional(),
    storageRef: z.string().optional(),
    metadata: z.record(z.unknown()).optional(),
});
export const exportArtifactSchema = z.object({
    /** Target SharePoint site ID or Teams channel drive ID */
    driveId: z.string().min(1),
    /** Folder path within the drive (e.g. "/Proclaw/Artifacts") */
    folderPath: z.string().min(1).default("/Proclaw/Artifacts"),
    /** Access token for Microsoft Graph API */
    accessToken: z.string().min(1),
});
//# sourceMappingURL=artifact.js.map